import { createContext } from "react";
import { iEnquiry } from "../interfaces/iEnquiry";

export const NoActionRequiredEnquiriesContext = createContext((enquiries: Array<iEnquiry>) => {});
